import AddCircleOutlineIcon from '@mui/icons-material/AddCircleOutlineOutlined'
import ListAltOutlinedIcon from '@mui/icons-material/ListAltOutlined'
import LogoutOutlinedIcon from '@mui/icons-material/LogoutOutlined'
import Box from '@mui/material/Box'
import Divider from '@mui/material/Divider'
import IconButton from '@mui/material/IconButton'
import Stack from '@mui/material/Stack'
import Tooltip from '@mui/material/Tooltip'
import { useNavigate } from 'react-router'

import { Logo } from '@/components/brand/Logo'

const RAIL_WIDTH = 72

export function SideRail({ onLogout }: { onLogout: () => void }) {
  const navigate = useNavigate()

  return (
    <Box
      component="nav"
      aria-label="Navegação principal"
      sx={{
        width: RAIL_WIDTH,
        flexShrink: 0,
        borderRight: 1,
        borderColor: 'divider',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        py: 2,
        gap: 2,
        // Sem o `alignSelf` o flex do shell estica o rail até a altura da
        // página inteira e o "Sair" do rodapé só aparece com a rolagem no fim.
        position: 'sticky',
        top: 0,
        alignSelf: 'flex-start',
        height: '100dvh',
        // Janela mais baixa que o conteúdo do rail: o rail rola sozinho e o
        // "Sair" continua alcançável.
        overflowY: 'auto',
        bgcolor: 'background.default',
        zIndex: (theme) => theme.zIndex.appBar,
      }}
    >
      <Logo size={36} withWordmark={false} />

      <Divider flexItem />

      <Stack spacing={1} sx={{ alignItems: 'center', flexGrow: 1 }}>
        <Tooltip title="Operações" placement="right">
          <IconButton onClick={() => void navigate('/')} aria-label="Operações">
            <ListAltOutlinedIcon />
          </IconButton>
        </Tooltip>

        <Tooltip title="Nova operação" placement="right">
          <IconButton onClick={() => void navigate('/transfers/new')} aria-label="Nova operação">
            <AddCircleOutlineIcon />
          </IconButton>
        </Tooltip>
      </Stack>

      <Tooltip title="Sair" placement="right">
        <IconButton onClick={onLogout} aria-label="Sair">
          <LogoutOutlinedIcon />
        </IconButton>
      </Tooltip>
    </Box>
  )
}
